module.exports = __webpack_public_path__ + "img/first-place.58f61359.png";